import { forwardRef as b } from "react";
import { link as k, icon as S, disabledIcon as v, label as L, valueWrapper as w, valueWrapperActive as W } from "./styles.js";
import { Link as g } from "../../../../Link/Link.js";
import "@material-bank/ds-utils";
import { Text as s } from "../../../../Typography/Text.js";
import { jsxs as j, jsx as e } from "theme-ui/jsx-runtime";
import { SelectValue as A } from "../../SelectValue/SelectValue.js";
import { CollapseArrow as I } from "../../../../CollapseArrow/CollapseArrow.js";
const P = b((i, a) => {
  const {
    selectedOption: c,
    open: l,
    placeholder: m,
    label: o,
    withUnderline: t = !0,
    disabled: n,
    children: d,
    getToggleButtonProps: r,
    labelSx: x,
    iconSx: f,
    valueWrapperSx: u,
    /* eslint-disable @typescript-eslint/no-unused-vars */
    getInputProps: T,
    /* eslint-enable @typescript-eslint/no-unused-vars */
    ...h
  } = i, p = {
    ref: a,
    disabled: n,
    ...h,
    sx: {
      ...k,
      ...i.sx
    }
  };
  return /* @__PURE__ */ j(g, {
    icon: /* @__PURE__ */ e(I, {
      open: l,
      sx: {
        ...S,
        ...n && v,
        ...f
      }
    }),
    ...(r == null ? void 0 : r(p)) ?? p,
    children: [o && /* @__PURE__ */ e(s, {
      sx: {
        ...L,
        ...x
      },
      children: o
    }), /* @__PURE__ */ e(s, {
      inherit: !0,
      ellipsis: !0,
      sx: {
        ...t && w,
        ...t && l && W,
        ...u
      },
      children: d ?? /* @__PURE__ */ e(A, {
        selectedOption: c,
        placeholder: m
      })
    })]
  });
});
P.displayName = "SelectLinkTrigger";
export {
  P as SelectLinkTrigger
};
